export const environment = {
  production: true,
  url: 'https://piqet-api-dev.ifourtechlab.com/api',
  signalRUrl: 'https://piqet-api-dev.ifourtechlab.com',
  piqetLcaApiUrl: 'https://localhost:44302/api/v1',
  locationPath: location.origin,
  primaryColor: '#D32F2F',
  // Microsoft Clarity project id — empty string disables tracking.
  clarityProjectId: '',
};
